import {NewtimeDropdownService} from './../../_services/newtime-dropdown.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ToastrService } from "ngx-toastr";
import Utils from '../../_util/utils';

@Component({
  selector: 'app-newtimepicker',
  templateUrl: './newtimepicker.component.html',
  styleUrls: ['./newtimepicker.component.scss'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class NewtimepickerComponent implements OnInit {
  @Input()
  form: NgForm;
  @Input() days =  this.timeDropdownService.getBlankDayArray();
  @Output()
  timePickerDataChange: EventEmitter<any> = new EventEmitter();
  constructor(private timeDropdownService: NewtimeDropdownService,
              private toastr: ToastrService,) { }

  ngOnInit() {
  }
  fromChange($event, index) {
    const arr = this.timeDropdownService.getTimeArray();
    const value = $event.target.value;
    
    // Update the 'from' value
    this.days[index]['from'] = value;
    
    
  
    // Check if From Time and To Time are the same
    if (value !== 'By Appt.' && this.days[index]['from'] === this.days[index]['to']) {
      this.toastr.error("From Time and To Time cannot be the same.");
      
      // Reset both 'from' and 'to' to 'By Appt.'
      this.days[index]['from'] = 'By Appt.';  // Set 'From' to 'By Appt.'
      this.days[index]['to'] = 'By Appt.';    // Set 'To' to 'By Appt.'
      
      // Reset the disabledUptoIndex for both 'from' and 'to'
      this.days[index]['disabledUptoIndex'] = arr.indexOf('By Appt.');
      
      // Emit the updated data
      this.timePickerDataChange.emit(this.days); 
      
      return; // Exit the function to prevent further processing
    }
  
    // Check if From Time is greater than To Time and reset if needed
    if (value !== 'By Appt.' && this.days[index]['from'] && value > this.days[index]['to']) {
      this.toastr.error("From Time cannot be greater than To Time.");
      
      // Clear From Time and To Time
      this.days[index]['from'] = 'By Appt.';
      this.days[index]['to'] = 'By Appt.';
      
      // Reset the disabledUptoIndex for both 'from' and 'to'
      this.days[index]['disabledUptoIndex'] = arr.indexOf('By Appt.');
      // Emit the updated data
      this.timePickerDataChange.emit(this.days);
      return;
    }
    
    // Update disabledUptoIndex when From Time is set
    if (value !== 'By Appt.') {
      this.days[index]['disabledUptoIndex'] = arr.indexOf(value);
    }
    if (value === 'By Appt.') {
      this.days[index]['to'] = 'By Appt.';
      this.days[index]['disabledUptoIndex'] = arr.indexOf(value);
      this.timePickerDataChange.emit(this.days);
      return;
    }
    // Emit the updated data
    this.timePickerDataChange.emit(this.days);
  }
  
  toChange($event, index) {
    const arr = this.timeDropdownService.getTimeArray();
    const value = $event.target.value;
    
    // Update the 'to' value
    this.days[index]['to'] = value;
    
    // If To Time is 'By Appt.', set From Time to 'By Appt.' as well
    if (value === 'By Appt.') {
      this.days[index]['from'] = 'By Appt.'; // Set From Time to 'By Appt.'
      this.days[index]['disabledUptoIndex'] = arr.indexOf('By Appt.');
      this.timePickerDataChange.emit(this.days);
      return; // Exit the function after setting 'By Appt.'
    }
    
    // If From Time and To Time are the same, show error and reset both
    if (this.days[index]['from'] === this.days[index]['to']) {
      this.toastr.error("From Time and To Time cannot be the same.");
      
      // Reset both 'from' and 'to' to 'By Appt.'
      this.days[index]['from'] = 'By Appt.';
      this.days[index]['to'] = 'By Appt.';
      
      // Reset the disabledUptoIndex
      this.days[index]['disabledUptoIndex'] = arr.indexOf('By Appt.');
      
      // Emit the updated data
      this.timePickerDataChange.emit(this.days);
      return; // Exit the function after resetting
    }
  
    // Emit the updated data
    this.timePickerDataChange.emit(this.days);
  }
  
  trackByDay(index: number, d: any): string {
    return d.day;
  }
}
